var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { InfoModalComponent } from "../../views/modal/info_modal.component";
import { AlertComponent } from "../../views/modal/alert.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { TranslateService } from "../../translate/translate.service";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { HelperService } from "../../lib/helper.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AccessorService } from "./accessor.service";
import { ChartParams } from "../../views/chart/chart.component";
var AccessorStatsModalComponent = /** @class */ (function (_super) {
    __extends(AccessorStatsModalComponent, _super);
    function AccessorStatsModalComponent(activeModal, helper, translate, modalService, filter, service) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.helper = helper;
        _this.translate = translate;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.service = service;
        _this.type = 'all';
        _this.chart = new ChartParams();
        return _this;
    }
    AccessorStatsModalComponent.prototype.ok = function () {
        this.close();
    };
    AccessorStatsModalComponent.prototype.updateChartData = function () {
        this.chart.data = this.stats.reduce(function (accessors, accessor) {
            accessors.push([
                accessor.email,
                accessor.totalCount
            ]);
            return accessors;
        }, []);
    };
    AccessorStatsModalComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var dateFilterParams, options, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.stats = null;
                        dateFilterParams = {
                            accessor: {
                                start: this.start,
                                end: this.end,
                                type: this.type
                            }
                        };
                        this.filter.filterParams.accessorDateFilter = this.filter.getApplyFilters({ dateFilterParams: dateFilterParams }).dateFilterParams.accessor;
                        options = { dateFilter: this.filter.filterParams.accessorDateFilter.type, start: this.filter.filterParams.accessorDateFilter.start, end: this.filter.filterParams.accessorDateFilter.end };
                        return [4 /*yield*/, this.service.getStats(options).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.stats = stats || [];
                        this.updateChartData();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorStatsModalComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.type = 'all';
                        this.stats = null;
                        _a = this;
                        return [4 /*yield*/, this.service.getStats({}).toPromise()];
                    case 1:
                        _a.stats = (_b.sent()) || [];
                        this.filter.filterParams.accessorDateFilter = { type: this.type, start: null, end: null };
                        this.updateChartData();
                        return [2 /*return*/];
                }
            });
        });
    };
    AccessorStatsModalComponent.prototype.downloadTopSites = function () {
        var params = this.helper.getUrlParams(this.filter.filterParams);
        window.location.href = this.service.dp.baseRoute + "/accessor2/top_download?" + params;
        this.modalService.open(AlertComponent, {
            title: 'INFO',
            message: this.translate.__A('common.download file')
        });
    };
    return AccessorStatsModalComponent;
}(InfoModalComponent));
export { AccessorStatsModalComponent };
